export default "__VITE_ASSET__889d7a8d__"